function createTaskDialogDirective () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/create-task/create-task-dialog.html?$$REVISION$$'
  }
}

export { createTaskDialogDirective }
